import { MprcConfirmDialog, MprcRequestIndicator } from 'components';
import { MprcRequestSnackbarErrorReport } from 'components/MprcRequestErrorReport';
import { useSnackbar } from 'notistack';
import { useCoreApi } from 'providers/CoreApiProvider';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';

////////////////////////////////////////////////////////////////////////////////

interface IProps {
    devPlanItemId: string;
    onClose: (success: boolean | null) => void;
}

////////////////////////////////////////////////////////////////////////////////

export const DeleteDevPlanItem: React.FC<IProps> = (props) => {

    const { devPlanItemId, onClose } = props;

    const api = useCoreApi();
    const { t } = useTranslation("lms");
    const { enqueueSnackbar } = useSnackbar();

    const [loading, setLoading] = useState<boolean>(false);

    ///
    const handleDelete = () => {

        setLoading(true);
        api.v1.devPlan.deleteItemGroup({ devPlanItemId: devPlanItemId })
            .then(response => {
                if (response.data === true) {
                    enqueueSnackbar(t("Record.DeleteSuccessMessage", { ns: "shared" }), { variant: "success" });
                    onClose(true);
                }
                else {
                    enqueueSnackbar(t("Record.DeleteFailMessage", { ns: "shared" }), { variant: "error" });
                }
            })
            .catch(e => MprcRequestSnackbarErrorReport(e))
            .finally(() => setLoading(false));
    };

    return <>

        <MprcRequestIndicator visible={loading} type={"post"} />
        <MprcConfirmDialog
            open
            severity="danger"
            message={t("DevPlan.Edit.View.DeleteItemConfirmMessage")}
            onClose={
                (yes) => {
                    if (yes) {
                        handleDelete();
                    } else {
                        onClose(false);
                    }
                }
            }
        />
    </>;
};
